<template lang="pug">
  app-modal.modal-images(type="default" size="xlarge", v-model="value.isOpen")
    app-messages(:errorMessages="errors", :successMessages="successes")
    //- 読み込み中はぐるぐる表示
    loading(v-if="isLoading === true", :height="450")
    file-droppable(
      v-else
      v-model="images"
      :main-image-id="mainId"
      :view_mode="true"
      :multi="true"
      type="image"
    )
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import AppModal from '@/components/templates/AppModal'
import FileDroppable from '@/components/organisms/FileDroppable'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const CardRepository = RepositoryFactory.get('bcard')
const UserRepository = RepositoryFactory.get('user')

export default {
  name: 'ModalImages',
  components: { AppMessages, AppModal, FileDroppable, Loading },
  props: {
    value: {
      type: Object,
      required: true,
      default () {
        return {
          isOpen: false,
          sid_bcard: null, // どちらか必須
          sid_user: null // どちらか必須
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      mainId: null,
      images: []
    }
  },
  watch: {
    'value.isOpen' (isOpen) {
      if (isOpen) {
        this.getData()
      }
    }
  },
  created () {
    if (this.value.isOpen) {
      this.getData()
    }
  },
  methods: {
    getData () {
      const vm = this
      this.clearMessages()
      this.isLoading = true
      this.mainId = null
      this.images = []

      let repository, method, id
      if (this.value.sid_bcard) {
        repository = CardRepository
        method = 'getImages'
        id = this.value.sid_bcard
      }
      else if (this.value.sid_user) {
        repository = UserRepository
        method = 'images'
        id = this.value.sid_user
      }

      if (!repository) return

      // API実行
      repository[method](id)
        .then(function (response) {
          vm.images = vm.getApiData(response).data
          for (let image of vm.images) {
            if (image.isMain === vm.app_flag.ON) {
              vm.mainId = image.sid_attach
              break
            }
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss">
// 注意：グローバルCSS
.modal.modal-images .bcard-file-droppable {
  height: 450px; // 各画面で上書き可能
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalImages.vue